module.exports = __webpack_public_path__ + "static/media/ohac.67ec1543.png";